
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/topic-pin/[keyword]",
      function () {
        return require("private-next-pages/topic-pin/[keyword].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/topic-pin/[keyword]"])
      });
    }
  